<script>
    import { _ } from 'svelte-i18n'
    import { info_client } from '../stores'

    export let createdDate

    $: getFormatDate = () => {
        const language = $info_client.language
        const objectDate = new Date(createdDate)
        const timeOptions = { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' }
        const dateOptions = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Europe/Moscow' }
        const time = objectDate.toLocaleTimeString(language, timeOptions)
        const date = objectDate.toLocaleDateString(language, dateOptions)

        return `${date} ${$_('at')} ${time}`.replaceAll('.', '')
    }
</script>

<span>{ getFormatDate() }</span>

<style lang="scss">
    span {
        white-space: nowrap;
    }
</style>